import { render } from "./SavedListGridItem.vue?vue&type=template&id=bb151b08"
import script from "./SavedListGridItem.vue?vue&type=script&lang=js"
export * from "./SavedListGridItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__